import { render, staticRenderFns } from "./cancel-extra-benefit-table.vue?vue&type=template&id=19d86eee&scoped=true&"
import script from "./cancel-extra-benefit-table.vue?vue&type=script&lang=js&"
export * from "./cancel-extra-benefit-table.vue?vue&type=script&lang=js&"
import style0 from "./cancel-extra-benefit-table.vue?vue&type=style&index=0&id=19d86eee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d86eee",
  null
  
)

export default component.exports